import { Interface } from '@ethersproject/abi'
import { BigNumber } from '@ethersproject/bignumber'
import { ChainId } from '../constants'
import { Pair } from '../model'
import { useChainCall } from './useChainCalls'
import { useEthers } from './useEthers'

export function useLiquidityBalance(pair?: Pair) {
  const { chainId, account } = useEthers()
  const data = useChainCall(getCall(chainId, pair, account))
  return data && pair ? BigNumber.from(data) : BigNumber.from(0)
}

const coder = new Interface(['function balanceOf (address) view returns (uint256)'])

function getCall(chainId?: ChainId, pair?: Pair, account?: string | null) {
  if (!pair || !pair.address || !account || pair.getChainId() !== chainId) {
    return
  }
  return { address: pair.address, data: coder.encodeFunctionData('balanceOf', [account]) }
}
